import { useNotification } from "@expert/common-ui";
import { useEffect } from "react";

import { sdkEventBus } from "@/sdk";

export const useWrapupToasts = () => {
    const notification = useNotification();

    useEffect(() => {
        const unsubFromWrapupEnded = sdkEventBus.on("wrapup_ended", ({ message, type }) => {
            notification[type](message);
        });

        return unsubFromWrapupEnded;
    }, [notification]);
};
